import React from 'react'
import { useRoutes } from 'react-router-dom'
import ClientPath from './client'
import MemberRoutes from './member'

const Routes: React.FC = (): JSX.Element => {

  const routing = useRoutes([...ClientPath, ...MemberRoutes])

  return <>{routing}</>
}

export default Routes
